import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Button } from "src/components-mui/base/button/button";

export interface IShowMoreButtonProps {
    isVisible: boolean;
    onClick: () => void;
}

export const ShowMoreButton = ({ isVisible, onClick }: IShowMoreButtonProps) => {
    const { t } = useTranslation("common");

    if (!isVisible) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                mt: 6,
            }}
        >
            <Button variant="outlined" onClick={onClick}>
                {t("show-more")}
            </Button>
        </Box>
    );
};
